import React, { useEffect, useState } from "react";

export default function Footer() {
  const [showBackTop, setShowBackTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowBackTop(window.scrollY >= 400);

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="site-footer">
      <button
        type="button"
        className={`back-top ${showBackTop ? "visible" : ""}`}
        onClick={scrollToTop}
        aria-label="Retour en haut"
      >
        <i className="fa-solid fa-arrow-up"></i>
      </button>
      <p>© 2026 Abdou Kowiyou Bachabi. Tous droits reserves.</p>
    </footer>
  );
}
